import React, { useState, useEffect } from "react";
import $, { error } from "jquery"; // Import jQuery
import "select2/dist/css/select2.css"; // Import the Select2 CSS
import axios from "axios";
import "select2";
import styles from '../Registration/Registration.module.css';
import { API_BASE_URL, verifyCode_api } from "../../../Apiconfig";
import { useNavigate } from "react-router-dom";

const Registration = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    otp: "",
    phone: "",
    shop_name: "",
    store_type: "",
    gst_tax: "",
    password: "",
    confirmPassword: "",
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  
  const navigate = useNavigate();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpLoading, setIsOtpLoading] = useState(false);

 // Function to send OTP (Verification Code)
const sendVerificationCode = async () => {
  setIsOtpLoading(true); // Set loading to true while the OTP is being sent

  try {
    const response = await axios.post(`${API_BASE_URL}/send_verification_code.php`, {
      email: formData.email,
    }, {
      withCredentials: true,  // Include credentials (cookies) in the request
    });

    // console.log(response.data);
    if (response.status === 200) {
      setIsOtpSent(true);  // Mark OTP as sent
      showCustomAlert("Verification code sent to your email.");
    } else {
      showCustomAlert("Failed to send verification code.");
    }
  } catch (error) {
    // console.error("Error sending OTP:", error);
    showCustomAlert("Error sending verification code. Please try again.");
  }

  setIsOtpLoading(false);  // Stop loading once the request is completed
};

// Handle the form submission after OTP verification
const handleSubmit = async (e) => {
  e.preventDefault();

  
  if (formData.password !== formData.confirmPassword) {
    showCustomAlert("Passwords do not match.");
    return;
  }

 
  if (!formData.otp) {
    showCustomAlert("Please enter the OTP.");
    return;
  }
// console.log(formData)
  try {
    // Send the registration data along with the OTP to the server
    const response = await axios.post(`${API_BASE_URL}/Registration_page.php`, formData, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true, 
    });

    // console.log(response.data);
    if (response.data.success === true) {
      showCustomAlert(response.data.message || "Registration successful!");
      navigate("/Log_in");
    } else {
      showCustomAlert(response.data.message || "Error during registration.");
    }
  } catch (error) {
    // console.error("Error during registration:", error);
    showCustomAlert("Error during registration. Please check the console for more details.");
  }
};
const showCustomAlert = (message) => {
  const alertBox = document.createElement('div');
  alertBox.innerText = message;
  alertBox.style.position = 'fixed';
  alertBox.style.top = '5%';
  alertBox.style.left = '50%';
  alertBox.style.transform = 'translate(-50%, -50%)';
  alertBox.style.padding = '10px 20px';
  alertBox.style.backgroundColor = '#4CAF50';
  alertBox.style.color = 'white';
  alertBox.style.fontSize = '16px';
  alertBox.style.borderRadius = '5px';
  alertBox.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
  alertBox.style.zIndex = '9999';

  document.body.appendChild(alertBox);

  // Remove the alert after 1 second
  setTimeout(() => {
    alertBox.remove();
  }, 3000);
};

  return (

    <>
     <div className={styles.overlayloginbgimg}> </div>
    <div className="d-flex justify-content-center align-items-center  ">

      {/* Form Card */}
      <div className="card shadow-lg border-0 rounded-3 my-4" style={{ width: "50rem" }}>
        <div className="card-header bg-secondry text-center ">
          <h1 className="fw-bold" style={{ color: "#1f2937", textDecoration: "underline" }}> Registration</h1>
        </div>

        <div className="card-body p-4">
          <form onSubmit={handleSubmit} className="row g-1" method="post" encType="multipart/form-data">
            {/* Username */}
            <div className="col-md-6">
              <label htmlFor="name" className="form-label fw-bold">
                Username
              </label>
              <input
                type="text"
                onChange={handleChange}
                value={formData.name}
                className="form-control"
                id="name"
                name="name"
                placeholder="Enter your username"
                required
                />
            </div>
            {/* Phone */}
            <div className="col-md-6">
              <label htmlFor="phone" className="form-label fw-bold">
                Phone
              </label>
              <input
                type="number"
                onChange={handleChange}
                value={formData.phone}
                className="form-control"
                id="phone"
                name="phone"
                placeholder="Enter your phone number"
                required
                />
            </div>
            {/* Email */}
            <div className="div">

              <label htmlFor="email" className="form-label fw-bold">
                Email
              </label>
            <div className="col-md-6 d-flex">
              <input
                type="email"
                onChange={handleChange}
                value={formData.email}
                className="form-control"
                id="email"
                name="email"
                placeholder="Enter your email"
                required
                />
              {/* Send verification button */}
              <button
                type="button"
                className="btn btn-info "
                onClick={sendVerificationCode}
                disabled={isOtpLoading}
                >
                {isOtpLoading ? "Sending..." : "Verify"}
              </button>

            </div>
            </div>


            {/* OTP */}
            <div className="col-md-6">
              <label htmlFor="otp" className="form-label fw-bold">
                OTP
              </label>
              <input
                type="number"
                onChange={handleChange}
                value={formData.otp}
                className="form-control"
                id="otp"
                name="otp"
                placeholder="Enter your OTP"
                required
                disabled={!isOtpSent}  // Disable input if OTP is not sent
                />
            </div>




            {/* Shop Name */}
            <div className="col-md-6">
              <label htmlFor="shop_name" className="form-label fw-bold">
                Shop Name
              </label>
              <input
                type="text"
                onChange={handleChange}
                value={formData.shop_name}
                className="form-control"
                id="shop_name"
                name="shop_name"
                placeholder="Enter your shop name"
                required
                />
            </div>

            {/* Store Type */}
            <div className="col-md-6">
              <label htmlFor="store_type" className="form-label fw-bold">
                Store Type
              </label>
              <select
                id="store_type"
                onChange={handleChange}
                value={formData.store_type}
                className="form-select"
                name="store_type"
                required
                >
                <option value="" disabled>
                  Select Store Type
                </option>
                <option value="Single Store">Single Store</option>
                <option value="Multiple Store">Multiple Store</option>
              </select>
            </div>

            {/* GST/TAX */}
            <div className="col-md-6">
              <label htmlFor="gst_tax" className="form-label fw-bold">
                GST/TAX
              </label>
              <input
                type="text"
                onChange={handleChange}
                value={formData.gst_tax}
                className="form-control"
                id="gst_tax"
                name="gst_tax"
                placeholder="Enter GST/TAX"
                
                />
            </div>

            {/* Password */}
            <div className="col-md-6">
              <label htmlFor="password" className="form-label fw-bold">
                Password
              </label>
              <div className="input-group">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  className="form-control"
                  onChange={handleChange}
                  value={formData.password}
                  id="password"
                  name="password"
                  placeholder="Password"
                  required
                  />
              
              </div>
            </div>

            {/* Confirm Password */}
            <div className="col-md-6">
              <label htmlFor="confirmPassword" className="form-label fw-bold">
                Confirm Password
              </label>
              <div className="input-group">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="form-control"
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Retype your password"
                  required
                  />
                <span
                  className="input-group-text bg-white border"
                  onClick={handleTogglePasswordVisibility}
                  style={{ cursor: "pointer" }}
                  >
                  <i
                    className={`fa ${isPasswordVisible ? "fa-eye-slash" : "fa-eye"}`}
                    aria-hidden="true"
                    ></i>
                </span>
              </div>
            </div>

            {/* Agreement */}
            <div className="col-md-6 p-4" >
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="terms"
                  required
                  />
                <label className="form-check-label" htmlFor="terms" >
                  I agree to the terms and conditions
                </label>
              </div>
            </div>

            <div className={`col-md-6 text-center p-2 ${styles.buttondivcontainer}`}>
              <button type="submit" className={` ${styles.registerButton} `} >Register</button>
            </div>
          </form>
        </div>
      </div>
    </div>
                  </>
  );
};

export default Registration;
